import Vue from  'vue'
import  Vuex from 'vuex'
// import http from './utils/axios';
// let axios = http();

Vue.use(Vuex)

const store =new Vuex.Store({
  state:{
    username: localStorage.getItem('username') ? localStorage.getItem('username') : '',
    usermobile: localStorage.getItem('usermobile') ? localStorage.getItem('usermobile') : '',
    workcode: localStorage.getItem('workcode') ? localStorage.getItem('workcode') : '',
    userToken: localStorage.getItem('userToken') ? localStorage.getItem('userToken') : '',
    permissionAgent:localStorage.getItem('permissionAgent') ? JSON.parse(localStorage.getItem('permissionAgent')) : '',
    defaultAgentIndex:localStorage.getItem('defaultAgentIndex') ? localStorage.getItem('defaultAgentIndex') : '',
    activeIndex:localStorage.getItem('activeIndex') ? localStorage.getItem('activeIndex') : 0,
    outStockDetail:[],
    giftDetail:[],
  },
  mutations:{
    changeUser(state,userinfo){
      state.username = userinfo.real_name;
      localStorage.setItem('username', userinfo.real_name);
      state.usermobile = userinfo.username;
      localStorage.setItem('usermobile', userinfo.username);
      state.workcode = userinfo.workcode;
      localStorage.setItem('workcode', userinfo.workcode);
    },
    changeToken(state,userToken){
      state.userToken = userToken;
      localStorage.setItem('userToken', userToken);
    },
    changePermissionAgent(state,permissionAgent){
      state.permissionAgent = permissionAgent;
      localStorage.setItem('permissionAgent', JSON.stringify(permissionAgent));
    },
    changeDefaultAgentIndex(state,defaultAgentIndex){
      state.defaultAgentIndex = defaultAgentIndex;
      localStorage.setItem('defaultAgentIndex', defaultAgentIndex);
    },
    changeActiveIndex(state,activeIndex){
      state.activeIndex = activeIndex;
      localStorage.setItem('activeIndex', activeIndex);
    },

    changeOutStockDetail(state,obj){
      //window.console.log(state.outStockDetail)
      //window.console.log(operator);
      if (obj.operator == 'del') {
        state.outStockDetail.splice(obj.index,1);
      }
      if (obj.operator == 'add') {
        state.outStockDetail.push({
          modelname:'',
          warehousename:'',
          quantity:'',
          stockID:'',
          warehouseId:'',
          branduuid:'',
          modeluuid:'',
          unit:'',
          unitcost:'',
          count:'',
          is_gift:'',
        })
      }
      if (obj.operator == 'update') {
        state.outStockDetail[obj.index].modelname = obj.modelname;
        state.outStockDetail[obj.index].warehousename = obj.warehousename;
        state.outStockDetail[obj.index].quantity = obj.quantity;
        state.outStockDetail[obj.index].stockID = obj.stockID;
        state.outStockDetail[obj.index].warehouseId = obj.warehouseId;
        state.outStockDetail[obj.index].branduuid = obj.branduuid;
        state.outStockDetail[obj.index].modeluuid = obj.modeluuid;
        state.outStockDetail[obj.index].unit = obj.unit;
        state.outStockDetail[obj.index].unitcost = obj.unitcost;
        state.outStockDetail[obj.index].is_gift = obj.is_gift;
      }
      if (obj.operator == 'clearall') {
        state.outStockDetail = [];

      }
    },
    changeGiftDetail(state,obj){
      //window.console.log(state.outStockDetail)
      //window.console.log(operator);
      if (obj.operator == 'del') {
        state.giftDetail.splice(obj.index,1);
      }
      if (obj.operator == 'add') {
        state.giftDetail.push({
          modelname:'',
          warehouseId:obj.warehouseId,
          branduuid:'',
          modeluuid:'',
          unit:'',
          unitcost:'',
          quantity:''  
        })
      }
      if (obj.operator == 'update') {
        state.giftDetail[obj.index].modelname = obj.modelname;
        state.giftDetail[obj.index].branduuid = obj.branduuid;
        state.giftDetail[obj.index].modeluuid = obj.modeluuid;
        state.giftDetail[obj.index].unit = obj.unit;
        state.giftDetail[obj.index].unitcost = obj.unitcost;
      }
      if (obj.operator == 'clearall') {
        state.giftDetail = [];

      }
      if (obj.operator == 'changeAllWarehouseSelected') {
        for(let i=0;i<state.giftDetail.length;i++) {
          state.giftDetail[i].warehouseId = obj.warehouseId;
        }

      }
      if (obj.operator == 'changeItemWarehouseSelected') {
        
        state.giftDetail[obj.index].warehouseId = obj.warehouseId;
        

      }

    },
  },
})

export default store